import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="px-4 py-3 sm:px-6 lg:px-8">
        <div className="flex justify-between text-sm text-gray-500">
          <div>© {new Date().getFullYear()} RISM Student Management System</div>
          <div>v1.0.0</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
